import React, { useEffect } from 'react'
import { CustomDropdown, CustomDropdownWithFilter, SectionTitle } from '../../../../../components'
import { filtrarCfops } from '../ValoresFiscaisCte/valoresFiscaisCte.util'
import { descreverPrestacao } from './ctePartes.util'

const estiloDica = { color: 'gray', fontSize: 12 }

export default function SecaoPrestacao({ form, cfops, cfopSelecionado, onCfopChange, ufEmissor }) {
  const cfopsFiltrados = filtrarCfops(cfops, ufEmissor, form.ufInicio, form.ufFim)
  const cfopSelecionadoId = cfopSelecionado ? cfopSelecionado.id : null

  useEffect(() => {
    if (cfopSelecionadoId && !cfopsFiltrados.some(cfop => cfop.id === cfopSelecionadoId)) {
      onCfopChange(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cfopSelecionadoId, ufEmissor, form.ufInicio, form.ufFim])

  // UF em coluna de 3/12: o dropdown do PrimeReact tem largura mínima e transborda em colunas menores
  const renderPonto = (ponto, titulo) => (
    <React.Fragment key={ponto}>
      <div className="p-md-3 p-col-12">
        <CustomDropdown
          optionLabel="uf"
          options={form.ufs}
          value={form.prestacao[ponto].uf}
          label={`UF ${titulo}:*`}
          filter={true}
          onChange={uf => form.onPrestacaoChange(ponto, { uf, city: null })}
        />
      </div>
      <div className="p-md-9 p-col-12">
        <CustomDropdownWithFilter
          optionLabel="name"
          options={form.cidadesPrestacao[ponto]}
          value={form.prestacao[ponto].city}
          label={`Cidade ${titulo}:*`}
          filter={true}
          disabled={!form.prestacao[ponto].uf}
          onChange={city => form.onPrestacaoChange(ponto, { city })}
        />
      </div>
    </React.Fragment>
  )

  return (
    <>
      <div className="p-col-12">
        <SectionTitle title="Prestação" />
        <span style={estiloDica}>{descreverPrestacao(ufEmissor, form.ufInicio, form.ufFim)}</span>
      </div>
      {renderPonto('inicio', 'Início')}
      {renderPonto('fim', 'Fim')}
      <div className="p-col-12">
        <CustomDropdown
          optionLabel="codigoNatureza"
          options={cfopsFiltrados}
          value={cfopSelecionado}
          label="CFOP:*"
          filter={true}
          onChange={onCfopChange}
          tooltip={
            'Lista filtrada pela UF do emissor e pelas UFs de início e fim da prestação (matriz da SEFAZ)'
          }
        />
      </div>
    </>
  )
}
